var openDrawer = document.getElementById('customer_register_link');
var openDrawerTablet = document.querySelector('.header-mobile__account');
var openDrawerMobile = document.querySelector('.customer_register-link--mobile');
var customerDrawer = document.querySelector('cart-drawer');
var closeDrawer = document.querySelector('cart-drawer .icon-close');
var mobileNav = document.querySelector('.header-mobile__menu.menu');
var html = document.querySelector('html');
var backdrop = document.querySelector('backdrop');

function toggleDrawer(){
    if(customerDrawer.classList.contains('drawer-is-open')){
        customerDrawer.classList.remove('drawer-is-open');
        html.style.overflowY = 'initial';
        html.style.overflowX = 'hidden';
        customerDrawer.style.display = 'none';

    } else {
        customerDrawer.classList.add('drawer-is-open');
        html.style.overflow = 'hidden';
        customerDrawer.style.display = 'block';
    }
}

function toggleDrawerMobile(){
    if(customerDrawer.classList.contains('drawer-is-open')){
        customerDrawer.classList.remove('drawer-is-open');
        customerDrawer.style.display = 'none';
        html.style.overflowY = 'initial';
        html.style.overflowX = 'hidden';
    } else {
        customerDrawer.style.display = 'block';
        customerDrawer.classList.add('drawer-is-open');
        mobileNav.classList.remove('toggle');
        html.style.overflow = 'hidden';
    }
}

openDrawer.addEventListener('click', toggleDrawer);
closeDrawer.addEventListener('click', toggleDrawer);
backdrop.addEventListener('click', toggleDrawer);
openDrawerTablet.addEventListener('click', toggleDrawer);
openDrawerMobile.addEventListener('click', toggleDrawerMobile);

var createAccount = document.querySelector('.create_account-ptag');
var loginAccount = document.querySelector('.login_account-ptag');
var loginContainer = document.querySelector('.customer-login');
var registerContainer = document.querySelector('.customer-register');
var registerIncentivesContainer = document.querySelector('.vip-incentives');

function toggleUI(){
    if(loginContainer.classList.contains('active')){
        loginContainer.classList.remove('active');
        registerContainer.classList.add('active');
        registerIncentivesContainer.classList.add('active');
    } else {
        registerContainer.classList.remove('active');
        registerIncentivesContainer.classList.remove('active');
        loginContainer.classList.add('active');
    }

    if(createAccount.classList.contains('active')){
        createAccount.classList.remove('active')
        loginAccount.classList.add('active')
    } else {
        loginAccount.classList.remove('active')
        createAccount.classList.add('active')
    }
}

createAccount.addEventListener('click', toggleUI);
loginAccount.addEventListener('click', toggleUI);